import React from 'react';
import './AfterVideoSection.css';

export default function AfterVideoSection() {
  return (
    <section className="after-video-section">
      <div className="avs-label">CONEXIONES, EXPERIENCIA, NEGOCIOS.</div>
      <h1 className="avs-title">RODÉATE DE GIGANTES</h1>
      <h2 className="avs-subtitle">
      IMPULSAMOS A EMPRENDEDORES Y EMPRESARIOS<br />
      a través de una plataforma de vinculación empresarial<br />
      diseñada para acelerar el crecimiento de sus negocios.
      </h2>
      <div className="avs-link">SOMOS CLUB EMPRESARIAL RECOMIENDA-T</div>
    </section>
  );
} 